import PropTypes from 'prop-types';
import React, { useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleThemesBlock = ({
    items,
    header
}) => {
    // misc
    const _items = items.map(itm => itm.theme).filter(Boolean);

    // state
    const [ showAllTags, setShowAllTags ] = useState(false);

    // state
    return (
        <div className='layout-container relative md:flex pt-40 pb-60 md:pt-100 md:pb-80'>
            {/* Spacer for desktop */}
            <div className='md:w-1/12' />
            <div className='md:w-11/12'>
                <h2 className='type-style-1'>{header ? header : 'Themes'}</h2>
                <div className='flex flex-wrap gap-10 mt-40 md:mt-60'>
                    {_items?.length <= 12 && _items.map((item, idx) => {
                        return (
                            <a
                                className='pill-button pill-button--large'
                                href={item.url}
                                key={idx}>
                                {item.title}
                            </a>
                        );
                    })}

                    {_items?.length > 12 && _items.slice(0, 12).map((item, idx) => {
                        return (
                            <a
                                className='pill-button pill-button--large'
                                href={item.url}
                                key={idx}>
                                {item.title}
                            </a>
                        );
                    })}

                    {_items?.length > 12 && (
                        <button
                            className={`${showAllTags ? 'hidden' : 'pill-button pill-button--large'}`}
                            onClick={() => { setShowAllTags(true); }}
                            type='button'>
                            &hellip;
                        </button>
                    )}

                    {showAllTags && _items?.slice(12).map((item, idx) => {
                        return (
                            <a
                                className='pill-button pill-button--large'
                                href={item.url}
                                key={idx}>
                                {item.title}
                            </a>
                        );
                    })}
                </div>
            </div>

        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.array,
    header: PropTypes.string,
};


ModuleThemesBlock.propTypes = propTypes;

export default ModuleThemesBlock;
